/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const RoutingEnum = {
    GET_ALL_ROUTES: '/network/routing',
    POST_ROUTE_ADD: '/network/routing',
    POST_ROUTE_DEL: (routeID: string): string => {
        return '/network/routing/' + routeID;
    },
    PUT_DEFAULTGW_SET: '/network/routing/defaultgw',
    DELETE_DEFAULTGW: (ipVersion: string): string => {
        return '/network/routing/defaultgw/' + ipVersion;
    }
};
